module.exports = __webpack_public_path__ + "static/img/EE.b20807ff.svg";